import { MY_MAP } from 'constants/text/home';
import {
    MapHeader,
    MapContentBox,
    MapImageBoxWrapper,
    MapImageBox,
    MapTextWrapper,
    MyMapInfoWrapper,
    Background,
    Content,
    ContentWrapper,
    Header,
    Description,
    IconContainer
} from '../MyMapInfo/MyMapInfo.styled';
import { ReactNode } from 'react';

type MyMapInfo = {
    title: string;
    description: ReactNode;
    action: ReactNode;
    icon?: ReactNode;
};
export const MyMapInfo = ({ title, description, action, icon }: MyMapInfo) => {
    return (
        <MyMapInfoWrapper>
            <Background />
            <ContentWrapper>
                <Header textColor="white">{MY_MAP}</Header>
                <Content>
                    <MapContentBox>
                        {icon ? <IconContainer>{icon}</IconContainer> : null}
                        <MapHeader>{title}</MapHeader>
                        <MapTextWrapper>
                            <Description>{description}</Description>
                        </MapTextWrapper>
                        {action}
                    </MapContentBox>
                    <MapImageBoxWrapper>
                        <MapImageBox />
                    </MapImageBoxWrapper>
                </Content>
            </ContentWrapper>
        </MyMapInfoWrapper>
    );
};
